import { render } from "./InquiryManageView.vue?vue&type=template&id=67ce95bf&scoped=true"
import script from "./InquiryManageView.vue?vue&type=script&lang=js"
export * from "./InquiryManageView.vue?vue&type=script&lang=js"

import "./InquiryManageView.vue?vue&type=style&index=0&id=67ce95bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ce95bf"]])

export default __exports__